import React from "react"
import { Row, Col, Button } from "react-bootstrap"
import { getDaysInMonth, getDay, isEqual, isWeekend, add, format, parse } from "date-fns"

const Calendar = ({ value, onChange }) => {
  const parsedValue = parse(value, 'yyyy-MM-dd', new Date());
  const startDate = new Date();

  const days = [];
  let currentDate = startDate;
  for (let m = 0; m < 6; ++m) {
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = add(startOfMonth, { months: 1, days: -1 });
    const padLeftDays = getDay(startOfMonth);
    const padRightDays = getDay(endOfMonth) === 6 ? 0 : 7 - getDay(endOfMonth) - 1;
    const daysInMonth = getDaysInMonth(startOfMonth);

    const ds = [];
    ds.push(...[...Array(padLeftDays).keys()].map(d => null));
    ds.push(...[...Array(daysInMonth).keys()].map(d => add(startOfMonth, { days: d })));
    ds.push(...[...Array(padRightDays).keys()].map(d => null));

    const chunked = [];
    for (let i = 0; i < ds.length; i += 7)
      chunked.push(ds.slice(i, i + 7));

    days.push({ month: startOfMonth, days: chunked });
    
    currentDate = add(currentDate, { months: 1 });
  }

  return <>
    {days.map(m => <React.Fragment key={`month_${format(m.month, 'yyyyMM')}`}>
      <Row className="g-0">
        <Col className="text-center my-2"><strong>{format(m.month, 'MMMM')}</strong></Col>
      </Row>

      {m.days.map((w, i) => <Row className="g-0" key={`week_${format(m.month, 'yyyyMM')}_${i}`}>
        {w.map((d, j) => <Col className="text-center" key={`day_${format(m.month, 'yyyyMM')}_${i}_${j}`}>
          {d && <Button
              variant={isEqual(parsedValue, d) ? 'primary' : 'white'}
              className="rounded-circle"
              disabled={d < new Date()}
              style={{
                width: '3rem',
                height: '3rem',
                fontWeight: isWeekend(d) ? '500' : 'normal'
              }}
              onClick={() => { onChange && onChange(format(d, 'yyyy-MM-dd')); console.log(d, parsedValue); }}
            >
              {format(d, 'd')}
            </Button>}
        </Col>)}
      </Row>)}
    </React.Fragment>)}
  </>;
}

export default Calendar